import { BrowserUtil } from '../BrowserUtil';
import AppConfig from '../domain/AppConfig';
import { UrlUtil } from '../UrlUtil';
import { getBaseDomain, getBaseComDomain, getEnvironment } from '../AppConfigUtil';
import { getServiceType, isAperzaCatalog, isAperzaCatalogTop, isAperzaSearchNewsResultPage, isAperzaCompanyPage, isAperzaNewsDomain, isAperzaAccountDomain, isAperzaBusinessDomain, isAperzaOrderDomain, isAperzaIdDomain, isAperzaMarketplace, isAperzaSearch, isAperzaSearchCatalogResultPage, isAperzaSearchItemResultPage, isAperzaSearchResultPage, isMainPage, isOrderCheckout, isBusinessOrders, isOrderRegister, isBusinessSignup, shouldShowMarketplaceTopBanner, getLangKey, getLangCode, } from '../AppQueryUtil';
export default class AppConfigService {
    static getHref() {
        // return window.location.href;
        return BrowserUtil.getHref();
    }
    static getDomain() {
        // return window.location.hostname.toLowerCase();
        return BrowserUtil.getHost();
    }
    static getPath() {
        // return window.location.pathname.toLowerCase();
        return BrowserUtil.getPath();
    }
    static getOrigin() {
        return BrowserUtil.getOrigin();
    }
    static isSsl() {
        return BrowserUtil.isSsl();
    }
    static getEnvironment() {
        return getEnvironment();
    }
    static getApiHostname() {
        const env = AppConfigService.getEnvironment();
        if (env === AppConfig.ENV_LOCAL) {
            return AppConfig.API_HOST_LOCAL;
        }
        if (env === AppConfig.ENV_TEST) {
            return AppConfig.API_HOST_TEST;
        }
        if (env === AppConfig.ENV_TEST_2) {
            return AppConfig.API_HOST_TEST;
        }
        if (env === AppConfig.ENV_STG) {
            return AppConfig.API_HOST_STG;
        }
        return AppConfig.API_HOST_PROD;
    }
    static getServiceType() {
        return getServiceType();
    }
    static getLangSwitchUrl(langCode) {
        const env = AppConfigService.getEnvironment();
        const searchWebHost = AppConfigService.getSearchWebHost(env);
        if (this.isAperzaCatalog()) {
            if (langCode === 'en') {
                return `${searchWebHost}/${langCode}${UrlUtil.getPath()}${UrlUtil.getSearch()}`;
            }
            let path = `${UrlUtil.getPath()}${UrlUtil.getSearch()}`;
            if (path.startsWith('/en')) {
                path = path.substring('/en'.length);
            }
            return `${searchWebHost}${path}`;
        }
        // return UrlUtil.replaceOrAddUrlParameterToHref('lang', langCode);
        let targetLangCode = 'ja';
        if (langCode === 'en') {
            targetLangCode = 'en';
        }
        let path = `${UrlUtil.getPath()}${UrlUtil.getSearch()}`;
        if (path.startsWith('/en') || path.startsWith('/ja')) {
            path = `/${targetLangCode}${path.substring('/en'.length)}`;
        }
        else {
            path = `/${targetLangCode}${path}`;
        }
        if (path.endsWith('/ja') || path.endsWith('/ja/')) {
            path = '';
        }
        if (this.isAperzaMarketplace()) {
            return `${AppConfigService.getMarketplaceWebHost(env)}${path}`;
        }
        return `${searchWebHost}${path}`;
    }
    static isAperzaAccountDomain() {
        return isAperzaAccountDomain();
    }
    static isAperzaIdDomain() {
        return isAperzaIdDomain();
    }
    static isAperzaOrderDomain() {
        return isAperzaOrderDomain();
    }
    static isAperzaBusinessDomain() {
        return isAperzaBusinessDomain();
    }
    static isAperzaNewsDomain() {
        return isAperzaNewsDomain();
    }
    static isAperzaSearch() {
        return isAperzaSearch();
    }
    static isAperzaCatalog() {
        return isAperzaCatalog();
    }
    static isAperzaCatalogTop() {
        return isAperzaCatalogTop();
    }
    static isOrderCheckout() {
        return isOrderCheckout();
    }
    static isOrderRegister() {
        return isOrderRegister();
    }
    static isBusinessSignup() {
        return isBusinessSignup();
    }
    static isBusinessOrders() {
        return isBusinessOrders();
    }
    static isAperzaMarketplace() {
        return isAperzaMarketplace();
    }
    // TODO to be merge with the same method in AppService
    static isMainPage() {
        return isMainPage();
    }
    static isAperzaSearchResultPage() {
        return isAperzaSearchResultPage();
    }
    static isAperzaSearchCatalogResultPage() {
        return isAperzaSearchCatalogResultPage();
    }
    static isAperzaCompanyPage() {
        return isAperzaCompanyPage();
    }
    static isAperzaSearchItemResultPage() {
        return isAperzaSearchItemResultPage();
    }
    static isAperzaSearchNewsResultPage() {
        return isAperzaSearchNewsResultPage();
    }
    static getCustomPageComponentElement() {
        const customPageComponent = document.getElementById('aperza-custompage-component');
        return customPageComponent;
    }
    static getBaseDomain(env) {
        return getBaseDomain(env);
    }
    static getBaseComDomain(env) {
        return getBaseComDomain(env);
    }
    static getTokenKey(env) {
        const key = 'atkn';
        if (env && env.length > 0) {
            return `${env}${key}`;
        }
        return key;
    }
    static getLangKey(env) {
        return getLangKey(env);
    }
    static getLangCode(env = AppConfigService.getEnvironment()) {
        return getLangCode(env);
    }
    static getBaseCluezMemberDomain(env) {
        if (env && env.length > 0) {
            if (env === 'stg') {
                return 'member.stg2.cluez.biz';
            }
            return `member.${env}.cluez.biz`;
        }
        return 'member.cluez.biz';
    }
    static getCdnHost(env) {
        if (env && env.length > 0) {
            // static-local-aperza-com s3 bucket looking.
            // aperza-style comment out
            if (env === 'local' || process.env.NODE_ENV === 'local') {
                return `//static.${env}.aperza.com:4000`;
            }
            return `//static.${env}.aperza.com`;
        }
        return '//static.aperza.com';
    }
    static getSearchWebHost(env) {
        if (env && env.length > 0) {
            if (env === AppConfig.ENV_LOCAL) {
                return `//www.${env}.aperza.com:8080`;
            }
            return `//www.${env}.aperza.com`;
        }
        return '//www.aperza.com';
    }
    static getAperzaTvHost(env) {
        if (env && env.length > 0) {
            if (env === AppConfig.ENV_LOCAL) {
                return `//tv.${env}.aperza.com:8050`;
            }
            return `//tv.${env}.aperza.com`;
        }
        return '//tv.aperza.com';
    }
    static getCloudPartnerHost(env) {
        if (env && env.length > 0) {
            if (env === AppConfig.ENV_LOCAL) {
                return `https://dx.${env}.aperza.com:18071/partner`;
            }
            return `//dx.${env}.aperza.com/partner`;
        }
        return '//dx.aperza.com/partner';
    }
    static getAccountWebHost(env) {
        if (env && env.length > 0) {
            return `//account.${env}.aperza.com`;
        }
        return '//account.aperza.com';
    }
    static getAperzaIdHost(env) {
        if (env && env.length > 0) {
            if (env === AppConfig.ENV_LOCAL) {
                return `//id.${env}.aperza.com:8000`;
            }
            return `//id.${env}.aperza.com`;
        }
        return '//id.aperza.com';
    }
    static getAperzaAccountHost(env) {
        if (env && env.length > 0) {
            return `//account.${env}.aperza.com`;
        }
        return '//account.aperza.com';
    }
    static getMarketplaceWebHost(env) {
        if (env && env.length > 0) {
            return `//ec.${env}.aperza.com`;
        }
        return '//ec.aperza.com';
    }
    static getAutomationNewsUrl(env) {
        if (env && env.length > 0) {
            return `//www.${env}.automation-news.jp`;
        }
        return '//www.automation-news.jp';
    }
    static getEnvLocaleBalloon(serviceType, env) {
        if (env && env.length > 0 && serviceType) {
            let prefix = serviceType;
            if (prefix.endsWith('-aperza')) {
                prefix = prefix.substring(0, prefix.indexOf('-aperza'));
            }
            return `${prefix}-${env}`;
        }
        return undefined;
    }
    static isSearchModel() {
        const path = AppConfigService.getPath();
        return path.includes('/s/model');
    }
    static isSearchItem() {
        const path = AppConfigService.getPath();
        return path.includes('/s/item');
    }
    static isSearchCatalog() {
        const path = AppConfigService.getPath();
        return path.includes('/s/catalog');
    }
    static isSearchNews() {
        const path = AppConfigService.getPath();
        return path.includes('/s/news');
    }
    static shouldShowMarketplaceTopBanner() {
        return shouldShowMarketplaceTopBanner();
    }
    static getSearchKeyword() {
        return UrlUtil.getUrlParameter('k');
    }
    /**
     *
     * @param whitelist optional whitelist for valid param names
     * @returns {{}} object whose property is the param name
     */
    static getSearchParams(whitelist = []) {
        const search = BrowserUtil.getSearch();
        if (search.startsWith('?') &&
            (AppConfigService.isSearchModel || AppConfigService.isSearchCatalog)) {
            const q = {};
            search
                .substring(1)
                .split('&')
                .forEach((i) => {
                let val = i.split('=')[1];
                val = decodeURIComponent(val);
                val = val.replace('+', ' ');
                const param = i.split('=')[0];
                if (whitelist.length === 0 || whitelist.includes(param)) {
                    q[i.split('=')[0]] = val;
                }
            });
            return q;
        }
        return {};
    }
    static appConfig() {
        const appConfig = new AppConfig();
        const env = AppConfigService.getEnvironment();
        appConfig.env = env;
        appConfig.baseDomain = AppConfigService.getBaseDomain(env);
        appConfig.baseComDomain = AppConfigService.getBaseComDomain(env);
        appConfig.tokenKey = AppConfigService.getTokenKey(env);
        appConfig.langKey = AppConfigService.getLangKey(env);
        appConfig.langCode = AppConfigService.getLangCode(env);
        appConfig.baseCluezMemberDomain = AppConfigService.getBaseCluezMemberDomain(env);
        appConfig.cdnHost = AppConfigService.getCdnHost(env);
        appConfig.serviceType = AppConfigService.getServiceType();
        appConfig.isAperzaCatalog = AppConfigService.isAperzaCatalog();
        appConfig.isAperzaCatalogTop = AppConfigService.isAperzaCatalogTop();
        appConfig.isAperzaMarketplace = AppConfigService.isAperzaMarketplace();
        appConfig.isAperzaSearchItemResultPage = AppConfigService.isAperzaSearchItemResultPage();
        appConfig.isAperzaSearchCatalogResultPage = AppConfigService.isAperzaSearchCatalogResultPage();
        appConfig.hideProductCategory = appConfig.isAperzaCatalog;
        appConfig.envLocaleBalloon = AppConfigService.getEnvLocaleBalloon(appConfig.serviceType, env);
        appConfig.searchWebHost = AppConfigService.getSearchWebHost(env);
        appConfig.accountWebHost = AppConfigService.getAccountWebHost(env);
        appConfig.marketplaceWebHost = AppConfigService.getMarketplaceWebHost(env);
        appConfig.automationNewsUrl = AppConfigService.getAutomationNewsUrl(env);
        appConfig.isAperzaNewsDomain = AppConfigService.isAperzaNewsDomain();
        appConfig.isAperzaIdDomain = AppConfigService.isAperzaIdDomain();
        appConfig.isAperzaAccountDomain = AppConfigService.isAperzaAccountDomain();
        appConfig.isAperzaOrderDomain = AppConfigService.isAperzaOrderDomain();
        appConfig.isOrderCheckout = AppConfigService.isOrderCheckout();
        appConfig.isAperzaBusinessDomain = AppConfigService.isAperzaBusinessDomain();
        appConfig.aperzaIdHost = AppConfigService.getAperzaIdHost(env);
        appConfig.aperzaAccountHost = AppConfigService.getAperzaAccountHost(env);
        appConfig.aperzaTvHost = AppConfigService.getAperzaTvHost(env);
        if (AppConfigService.isAperzaMarketplace()) {
            appConfig.mainPage = appConfig.marketplaceWebHost;
        }
        else if (AppConfigService.isAperzaCatalog()) {
            appConfig.mainPage = `${appConfig.searchWebHost}/catalog`;
        }
        else {
            appConfig.mainPage = appConfig.searchWebHost;
        }
        if (appConfig.langCode !== 'ja') {
            appConfig.mainPage = `${appConfig.mainPage}/${appConfig.langCode}/`;
        }
        return appConfig;
    }
    /**
     * resolves configurations per domain
     */
    static resolveHeaderConfigurations() {
        if (AppConfigService.isAperzaMarketplace()) {
            // verify marketplace first as the service is both APERZA_SEARCH for different domains
            return AppConfigService.resolveHeaderConfigurationsEc();
        }
        if (AppConfigService.isAperzaCatalogTop()) {
            // verify catalog first, as service for catalog is also APERZA_SEARCH
            return AppConfigService.resolveHeaderConfigurationsCatalog();
        }
        if (AppConfigService.isAperzaSearch()) {
            return AppConfigService.resolveHeaderConfigurationsSearch();
        }
        if (AppConfigService.isAperzaIdDomain()) {
            return AppConfigService.resolveHeaderConfigurationsId();
        }
        if (AppConfigService.isAperzaAccountDomain()) {
            return AppConfigService.resolveHeaderConfigurationsAccount();
        }
        if (AppConfigService.isAperzaOrderDomain()) {
            return AppConfigService.resolveHeaderConfigurationsOrder();
        }
        if (AppConfigService.isAperzaBusinessDomain()) {
            return AppConfigService.resolveHeaderConfigurationsBusiness();
        }
        if (AppConfigService.isAperzaNewsDomain()) {
            return AppConfigService.resolveHeaderConfigurationsNews();
        }
        // Default to search config
        return AppConfigService.resolveHeaderConfigurationsSearch();
    }
    static resolveHeaderConfigurationsSearch() {
        const config = AppConfigService.defaultHeaderConfigurations();
        return Object.assign(config, {
            disableSuggest: AppConfigService.isMainPage(),
            disableAperzaTv: false,
        });
    }
    static resolveHeaderConfigurationsEc() {
        const config = AppConfigService.defaultHeaderConfigurations();
        return Object.assign(config, {
            disableSuggest: AppConfigService.isMainPage(),
            disableNavCategory: false,
            disableNavCatalog: true,
            disableNavMarketplace: true,
            disableNavNews: true,
            disableNavExhibitions: true,
            disableNavManufacturers: false,
            disableNavShops: false,
            disableMarketplaceBanner: false,
            disableAperzaTv: false,
        });
    }
    static resolveHeaderConfigurationsCatalog() {
        const config = AppConfigService.defaultHeaderConfigurations();
        return Object.assign(config, {
            disableSuggest: true,
            disableAperzaTv: false,
        });
    }
    static resolveHeaderConfigurationsId() {
        const config = AppConfigService.defaultHeaderConfigurations();
        return Object.assign(config, {
            disableAperzaTv: false,
        });
    }
    static resolveHeaderConfigurationsAccount() {
        const config = AppConfigService.defaultHeaderConfigurations();
        return Object.assign(config, {
            disableAperzaTv: false,
        });
    }
    static resolveHeaderConfigurationsOrder() {
        const config = AppConfigService.defaultHeaderConfigurations();
        if (AppConfigService.isOrderCheckout() || AppConfigService.isOrderRegister()) {
            return Object.assign(config, {
                // disable all
                disableSuggest: true,
                disableCartBadge: true,
                disableLogin: true,
                disableNavBar: true,
                disableNavCategory: true,
                disableNavCatalog: true,
                disableNavMarketplace: true,
                disableNavNews: true,
                disableNavExhibitions: true,
                disableNavManufacturers: true,
                disableNavShops: true,
                disableNavPromote: true,
                disableNavRegisterAccount: true,
            });
        }
        // any other order page
        return Object.assign(config, {
            disableNavCategory: false,
            disableNavCatalog: true,
            disableNavMarketplace: true,
            disableNavNews: true,
            disableNavExhibitions: true,
            disableNavManufacturers: false,
            disableNavShops: false,
            disableMarketplaceBanner: false,
        });
    }
    static resolveHeaderConfigurationsBusiness() {
        const config = AppConfigService.defaultHeaderConfigurations();
        if (AppConfigService.isBusinessSignup()) {
            return Object.assign(config, {
                // disable all
                disableSuggest: true,
                disableCartBadge: true,
                disableLogin: true,
                disableNavBar: true,
                disableNavCategory: true,
                disableNavCatalog: true,
                disableNavMarketplace: true,
                disableNavNews: true,
                disableNavExhibitions: true,
                disableNavManufacturers: true,
                disableNavShops: true,
                disableNavPromote: true,
                disableNavRegisterAccount: true,
            });
        }
        // any other order page
        return Object.assign(config, {
            disableNavCategory: false,
            disableNavCatalog: true,
            disableNavMarketplace: true,
            disableNavNews: true,
            disableNavExhibitions: true,
            disableNavManufacturers: false,
            disableNavShops: false,
            disableMarketplaceBanner: false,
        });
    }
    static resolveHeaderConfigurationsNews() {
        const config = AppConfigService.resolveHeaderConfigurationsSearch();
        return Object.assign(config, {
            disableNavBar: true,
        });
    }
    static defaultHeaderConfigurations() {
        return {
            disableSuggest: false,
            disableCartBadge: false,
            disableLogin: false,
            disableNavBar: false,
            disableNavCategory: false,
            disableNavCatalog: false,
            disableNavMarketplace: false,
            disableNavNews: false,
            disableNavExhibitions: false,
            disableNavManufacturers: true,
            disableNavShops: true,
            disableNavPromote: false,
            disableNavRegisterAccount: false,
            disableMarketplaceBanner: true,
            disableAperzaTv: true,
        };
    }
}
export { AppConfigService };
